import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";

type HasPagePermission = (permissionId: string) => boolean;

const REPORT_NAVIGATION_ITEMS = [
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsRoleAssignments) &&
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsSettlements),
    url: "/reports/attorney-summary",
  },
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsRoleAssignments) &&
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsSettlements),
    url: "/reports/case-assignments",
  },

  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersClosed),
    url: "/reports/closed-matters",
  },
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersAll),
    url: "/reports/open-matters",
  },
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsDemands),
    url: "/reports/demands",
  },
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsDemands),
    url: "/reports/demand-summary",
  },
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsRecordRequests),
    url: "/reports/record-requests",
  },
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsSettlements),
    url: "/reports/settlement-summary",
  },
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.firmReportsUserActivity),
    url: "/reports/user-productivity",
  },
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsApproachingStatutes),
    url: "/reports/approaching-statutes",
  },
  // Temporarily hidden reports; keep order here for quick re-enable.
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsActivity),
    url: "/reports/matter-activity",
  },
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsPerStatus),
    url: "/reports/matter-status-count",
  },
  {
    canAccess: (hasPagePermission: HasPagePermission) =>
      hasPagePermission(PAGE_PERMISSION_KEYS.mattersReportsRoleAssignments),
    url: "/reports/role-assignments",
  },
] as const;

export const getFirstAccessibleReportRoute = (
  hasPagePermission: HasPagePermission,
): string | undefined =>
  REPORT_NAVIGATION_ITEMS.find((item) => item.canAccess(hasPagePermission))
    ?.url;

export const hasAnyAccessibleReport = (
  hasPagePermission: HasPagePermission,
): boolean => Boolean(getFirstAccessibleReportRoute(hasPagePermission));

export const canAccessReportsArea = (
  hasPagePermission: HasPagePermission,
): boolean => hasAnyAccessibleReport(hasPagePermission);
